module.exports = __webpack_public_path__ + "assets/img/slogan-d4104c4b.png";